// Menü initialisieren ================================================================================

import { Browser } from './browsercheck';

export function openActiveLevel(selector) {
    // Slide down the current level
    $(`${selector} li.submenu.active, ${selector} li.submenu.trail`).children('ul').stop().slideDown(0);

    // Add open class to submenu link
    $(`${selector} li.active`).parent().parent().children('a').addClass('open');
}

export function closeActiveLevel(selector) {
    // Slide up possible open submenus on resize
    $(`${selector} li.submenu.active, ${selector} li.submenu.trail`).children('ul').stop().slideUp(0);
}

export function resetMobileMenu(options) {
    const $menu = $(options.selector);

    for (let i = 1; i < options.levels; i++) {
        $menu.add('.level_' + i);
    }

    $menu.css('display', '');
    $(options.navButton).removeClass('active');

    closeActiveLevel(options.selector);
}

// Overlay per CLose-Button oder Klick auf Hintergrund schließen
export function closeOverlayOnBgClick(selector) {
    $(selector).on('click', function (e) {
        if ($(this).find('.overlay_inside, .overlay-close').is(e.target)) {
            $(this).fadeOut(300);
        }
    });
}

/**
 * @param {import('../components/menu').MenuOptions} Menu
 */
export function registerjQueryHoverMenu(Menu) {
    jQuery.fn.extend({
        hoverMenu: function (level) {
            $(this).on('mouseenter', function () {
                openNavLevelOnHover(level, 'down', this);
            });

            $(this).on('mouseleave', function () {
                openNavLevelOnHover(level, 'up', this);
            });

            $(this)
                .children('a,strong')
                .on('click', function (e) {
                    openNavLevelOnClick(e, level, $(this).parent().get(0));
                });
        },
    });

    function openNavLevelOnHover(level, action, el) {
        if (Menu.inMobileMode() || Browser.isTouchDevice) {
            return;
        }

        const $ul = $(el).find('.level_' + level);

        switch (action) {
            case 'up':
                $ul.stop().slideUp('fast');

                break;

            case 'down':
                $ul.stop().slideDown('fast');

                break;

            case 'toggle':
                $ul.stop().slideToggle('fast');

                break;
        }

        $(`${Menu.selector} .level_${level - 1} > li.submenu`)
            .not($(el))
            .find('a')
            .removeClass('open');

        $(el).children('a').toggleClass('open');
    }

    function openNavLevelOnClick(event, level, el) {
        if (!Browser.isTouchDevice) {
            return;
        }

        event.preventDefault();

        const $ul = $(`${Menu.selector} .level_${level}`);
        const $clicked = $(el).find('.level_' + level);

        $ul.not($clicked).slideUp(0);

        $clicked.stop().slideToggle(0);

        $(`${Menu.selector} .level_${level - 1} > li.submenu > a`)
            .not($(el).children('a'))
            .removeClass('open');

        $(el).children('a').toggleClass('open');
    }
}
